import { GTCItem } from './GTCItem';

export default GTCItem;
